import React from "react";
import "./hardware.css";
import { BsBagCheckFill, BsBagDash } from "react-icons/bs";

export default function Hardware() {
  return (
    <div className="hardware">
      <h3>Hardwares</h3>
      <div className="models">
        <div className="partA">
          <div className="instance1">
            <h2>Lite Edition</h2>
            <div className="checks">
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Cellular Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>GPS/GNSS Module</h3>
              </li>
              <li className="check">
                <BsBagDash className="importedicons" />
                <h3>Mortion Sensor</h3>
              </li>
              <li className="check">
                <BsBagDash className="importedicons" />
                <h3>Geofencing</h3>
              </li>
              <li className="check">
                <BsBagDash className="importedicons" />
                <h3>Fuel Reporting</h3>
              </li>
              <li className="last">
                <BsBagDash className="importedicons" />
                <h3>AI Stranger Recognition</h3>
              </li>
            </div>
            <button>Order</button>
          </div>
          <div className="instance">
            <h2>Basic Edition</h2>
            <div className="checks">
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Cellular Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>GPS/GNSS Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Mortion Sensor</h3>
              </li>
              <li className="check">
                <BsBagDash className="importedicons" />
                <h3>Geofencing</h3>
              </li>
              <li className="check">
                <BsBagDash className="importedicons" />
                <h3>Fuel Reporting</h3>
              </li>
              <li className="last">
                <BsBagDash className="importedicons" />
                <h3>AI Stranger Recognition</h3>
              </li>
            </div>
            <button>Order</button>
          </div>
        </div>
        <div className="partB">
          <div className="instance3">
            <h2>Standard Edition</h2>
            <div className="checks">
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Cellular Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>GPS/GNSS Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Mortion Sensor </h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Geofencing</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Fuel Reporting</h3>
              </li>
              <li className="last">
                <BsBagDash className="importedicons" />
                <h3>AI Stranger Recognition</h3>
              </li>
            </div>
            <button>Order</button>
          </div>

          <div className="instance">
            <h2>Premium Edition </h2>
            <div className="checks">
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Cellular Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>GPS/GNSS Module</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Mortion Sensor</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Geofencing</h3>
              </li>
              <li className="check">
                <BsBagCheckFill className="importedicons" />
                <h3>Fuel Reporting</h3>
              </li>
              <li className="last">
                <BsBagCheckFill className="importedicons" />
                <h3>AI Stranger Recognition</h3>
              </li>
            </div>
            <button>Order</button>
          </div>
        </div>
      </div>
      <div className="lowerspacer" />
    </div>
  );
}
